import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { approveSuppliers, getMasterSuppliersForQA, rejectSuppliers, getLocationBasedMasterSuppliersForQA, getLocationMasterSuppliersCountForQA, getChildSuppliersCountForQA, getMasterSuppliersCountForQA, getMasterSuppliers, getMatchedChildOrphans, getLocationMastersByMasterIds, updateReEnablement } from '../../redux/actions/vendor'
import QualityMasterSuppliersComponent from './master-supplier'
import QualityLocationBasedMasterSuppliersComponent from './location-based-master-supplier'
import QaNotesModal from './modals/qa-notes-modal'
import { addSupplierHistory } from '../../redux/actions/vendor'
import {
  getMasterSupplierDetailsById,
  getChildSuppliersWithMasterId,
  getRelatedSupplierDetailsById
} from '../../redux/actions/vendor'
import AutoMatchedChildren from './autoMatchedChildren'
import { toast } from '../CommonComponents/ToastComponent/toast'
import CommonContainer from '../CommonContainer';

const QualityComponent = () => {
  //------------------ insert tabs ---------------
  const [matchedChildOrphans, setMatchedChildOrphans] = useState([])
  const [selectedMatchedChildOrphans, setSelectedMatchedChildOrphans] = useState([])
  const [totalMatchedChildRecords, setTotalMatchedChildRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [isLoadingOrphans, setIsLoadingOrphans] = useState(false)
  const [relatedSupplierData, setRelatedSupplierData] = useState([])
  const [totalMasterRecords, setTotalMasterRecords] = useState(0)
  const [totalLocationBasedMasterRecords, setTotalLocationBasedMasterRecords] = useState(0)

  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === matchedChildOrphans.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < matchedChildOrphans.length) {
    indeterminate = true;
  }

  const handleCheckAll = (value, checked) => {
    const keys = checked ? matchedChildOrphans.map(item => item.id) : [];
    setCheckedKeys(keys);
  };

  const handleCheck = (value, checked) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
    const selectedPendingSups = [...selectedMatchedChildOrphans]

    let isExist = selectedPendingSups.some(supplier => supplier.id === value)
    if (!isExist) {
      const sup = matchedChildOrphans.filter(supplier => supplier.id === value)
      selectedPendingSups.push(sup[0])
    } else {
      const index = selectedPendingSups.findIndex(supplier => supplier.id === value)
      if (index !== -1) {
        selectedPendingSups.splice(index, 1)
      }
    }
    setSelectedMatchedChildOrphans(selectedPendingSups)
    setCheckedKeys(keys);
  };

  const param = window.location.href.split('qa/')[1]
  const param1 = window.location.href.split('qa/relatedsupplier/')[1]

  const getMatchedChildren = async (page, limit, offset, searchList, sortType = 'asc', sortColumn = 'suppliername') => {
    let createdLocationMasters = []
    setIsLoadingOrphans(true)
    await dispatch(getMatchedChildOrphans(page, limit, offset, searchList, sortType, sortColumn)).then(async (res) => {
      let masterIds = res?.matchedChildOrphans.map(sup => sup?.masterId)
      const locMasterIds = res?.masterSupCardDetails.filter(master => master?.isAcceptGlobalAcceptance === false) // to find location masters created if Global Acceptance is false
      if (locMasterIds && locMasterIds?.length > 0) {
        createdLocationMasters = await dispatch(getLocationMastersByMasterIds(masterIds)).then((locationSupDetails) => {
          return locationSupDetails
        }).catch(err => {
          toast.show({
            title: 'Warning',
            description: 'Unable To Get Matched Child Orphans'
          })
        })
      }

      const finalResults = res?.matchedChildOrphans.length > 0 ? res.matchedChildOrphans.map(sup => {
        let locationSup = []
        let tmp = res?.matchedSupplierGeneralInfo.filter((matchedSup) => matchedSup?.matchedSupplierId === sup?.matchedSupplierId)
        let cardAccTmp = res?.masterSupCardDetails.filter(master => master.supplierId === sup?.masterId)
        if (locMasterIds && locMasterIds?.length > 0) {
          locationSup = createdLocationMasters?.filter((locationSup) => locationSup?.masterId === sup?.masterId && locationSup?.primaryMasterId === sup?.masterId && locationSup?.isMaster)
        }
        let acceptanceType = ''
        if (cardAccTmp[0]?.isAcceptGlobalAcceptance === true) {
          acceptanceType = 'Global'
        } else if (cardAccTmp[0]?.isAcceptGlobalAcceptance === null) {
          acceptanceType = 'Unknown'
        } else if (cardAccTmp[0]?.isAcceptGlobalAcceptance === false) {
          if (locationSup?.length > 0) {
            acceptanceType = 'Location'
          } else {
            acceptanceType = 'Selective'
          }
        }
        return { ...sup, ...tmp[0], ...cardAccTmp[0], acceptanceType, locationMaster: locationSup }
      }) : []

      await dispatch(getLocationMastersByMasterIds(masterIds)).then((locationSupDetails) => {
        setIsLoadingOrphans(false)

        setMatchedChildOrphans(finalResults)
        setTotalMatchedChildRecords(res?.totalRecords)
      }).catch(err => {
        setIsLoadingOrphans(false)
        toast.show({
          title: 'Warning',
          description: 'Unable To Get Matched Child Orphans'
        })
      })
    }).catch(err => {
      setIsLoadingOrphans(false)
      toast.show({
        title: 'Warning',
        description: 'Unable To Get Matched Child Orphans'
      })
    })
  }

  const onChangePageHandler = async (event) => {
    setPage(event)
    let tmpOffset = limit * (event - 1)
    getMatchedChildren(event, limit, tmpOffset, {})
  }

  const handleChangeLimit = (e) => {
    setLimit(e)
    setPage(1)
    getMatchedChildren(1, e, 0)
  }

  useEffect(() => {
    if (param1 != undefined && param1 != '') {
      handleGoToRelatedSupply(param1)
    } else {
      if (param != undefined && param != '')
        handleGoToSupply(param)
    }
  }, [])

  const tabs = [
    {
      label: 'Supplier Matching',
      value: 'lookup',
    }, {
      label: 'Auto-Matched Children',
      value: 'autoMatchedChildren',
    }
  ]
  const [currentTab, setCurrentTab] = useState('lookup')
  const handleClickTab = (tab) => {
    if (tab === "autoMatchedChildren") {
      setPage(1)
      getMatchedChildren(1, 10, 0, {})
    }
    setCurrentTab(tab)
    setCheckedKeys([])
    setSearchSupplier("")
    setSelectedMatchedChildOrphans([])
  }

  const handleGoToSupply = (masterId) => {
    handleClickTab('supply');
    dispatch(
      getMasterSupplierDetailsById(masterId)
    )
    dispatch(
      getChildSuppliersWithMasterId(masterId)
    )
  }

  const handleGoToRelatedSupply = (relatedSupplierId) => {
    handleClickTab('relatedsupply');
    dispatch(
      getRelatedSupplierDetailsById(relatedSupplierId)
    ).then((res) => {
      setRelatedSupplierData(res.relatedSupplierInfo)
    }).catch((err) => {
      console.log(err)
    })
  }
  //--------------------------------------
  const [searchSupplier, setSearchSupplier] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const dateFromRef = useRef();
  const dateToRef = useRef();

  const [searchBoolean, setSearchBoolean] = useState(false);
  const store = useStore().getState()
  const dispatch = useDispatch()

  const {
    vendor: { suppliersForQA, masterSuppliersForQA, isLoadingChildSupplier, isLoadingMasterSupplier, isLoadingLocationMasterSupplier, locationBasedMasterSuppliersForQA },
    auth: { user }
  } = store

  const [lookupTableData, setLookupTableData] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const [locationBasedMasterTableData, setLocationBasedMasterTableData] = useState([])
  const [searchList, setSearchList] = useState({})
  const [search, setSearch] = useState(false);

  const [showQaPromt, setShowQaPromt] = useState(false)
  const [checkedIds, setCheckedIds] = useState([])
  const [qaType, setQaType] = useState('')
  const [qaSupplierType, setQaSupplierType] = useState('')

  const [selectedMasterIds, setSelectedMasterIds] = useState([])
  const [selectedChildrens, setSelectedChildrens] = useState([])
  const [suppliersDataParams, setSuppliersDataParams] = useState({
    limit: 10,
    page: 1,
    showPending: true,
    showApproved: false,
    showRejected: false
  })
  const [isQANoteSubmitted, setIsQANoteSubmitted] = useState(false)

  const searchOptions = [
    {
      label: 'Both',
      value: 'both',
    },
    {
      label: 'Child Suppliers',
      value: 'child',
    },
    {
      label: 'Master Suppliers',
      value: 'master',
    },
    {
      label: 'Location Master Suppliers',
      value: 'locationMaster',
    }
  ]

  const [searchTarget, setSearchTarget] = useState(searchOptions[0])

  const filterChildSuppliers = useCallback((searchList) => {
    const tmpTableData = [...suppliersForQA]?.filter(row => {
      let status = true
      if (Object.keys(searchList).length > 0) {
        Object.keys(searchList).forEach(searchName => {
          const strSearch = searchList[searchName].toString().toUpperCase()
          const strFieldValue = row[searchName]?.toString().toUpperCase() || ""
          if (searchName === 'address') {
            const address1 = row['address1']?.toString().toUpperCase() || ""
            const address2 = row['address2']?.toString().toUpperCase() || ""

            if (strSearch !== "" && (!address1.includes(strSearch) && !address2.includes(strSearch))) {
              status = false
            }
          } else if (strSearch !== "" && !strFieldValue.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })
    setLookupTableData(tmpTableData)
  }, [suppliersForQA])

  const filterLocationBasedMasterSuppliers = useCallback((searchList) => {
    const tmpTableData = [...locationBasedMasterSuppliersForQA]?.filter(row => {
      let status = true
      if (Object.keys(searchList).length > 0) {
        Object.keys(searchList).forEach(searchName => {
          const strSearch = searchList[searchName].toString().toUpperCase()
          const strFieldValue = row[searchName]?.toString().toUpperCase() || ""
          if (searchName === 'address') {
            const address1 = row['address1']?.toString().toUpperCase() || ""
            const address2 = row['address2']?.toString().toUpperCase() || ""

            if (strSearch !== "" && (!address1.includes(strSearch) && !address2.includes(strSearch))) {
              status = false
            }
          } else if (strSearch !== "" && !strFieldValue.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })
    setLocationBasedMasterTableData(tmpTableData)
  }, [locationBasedMasterSuppliersForQA])

  useEffect(() => {
    if (!suppliersForQA || suppliersForQA.length === 0) {
      return
    }
    if (searchTarget.value === 'both' || searchTarget.value === 'child') {
      filterChildSuppliers(searchList)
    } else if (searchTarget.value === 'master') {
      setLookupTableData(suppliersForQA)
    }
  }, [suppliersForQA, filterChildSuppliers])

  useEffect(() => {
    if (!locationBasedMasterSuppliersForQA || locationBasedMasterSuppliersForQA.length === 0) {
      return
    }
    if (searchTarget.value === 'both' || searchTarget.value === 'locationMaster') {
      filterLocationBasedMasterSuppliers(searchList)
    } else if (searchTarget.value === 'master') {
      setLookupTableData(suppliersForQA)
    }
  }, [locationBasedMasterSuppliersForQA, filterLocationBasedMasterSuppliers])

  const handleApproveSuppliers = (ids, type, limit, page, showPending, showApproved, showRejected) => {
    setCheckedIds(ids)
    setQaType('approve')
    setQaSupplierType(type)
    setSuppliersDataParams({
      ...suppliersDataParams,
      limit,
      page,
      showPending,
      showApproved,
      showRejected
    })
    handleSubmitQA('', ids, 'approve', type, {
      limit,
      page,
      showPending,
      showApproved,
      showRejected
    })
  }

  const handleRejectSuppliers = (ids, type, limit, page, showPending, showApproved, showRejected) => {
    setCheckedIds(ids)
    setShowQaPromt(true)
    setQaType('reject')
    setQaSupplierType(type)
    setSuppliersDataParams({
      ...suppliersDataParams,
      limit,
      page,
      showPending,
      showApproved,
      showRejected
    })
  }


  const onConfirmAndReenable = async () => {
    await dispatch(updateReEnablement(checkedIds)).then((res) => {
    }).catch((res) => {
      toast.show({
        title: 'Warning',
        description: 'Unable to update the reenablement',
      })
    })
  }

  const handleSubmitQA = async (qaNotes, ids = null, type = '', supType = '', supplierParams = null, page = '', isReenable = false) => {
    let tmpQaType = type ? type : qaType
    let supIds = ids ? ids : checkedIds
    var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
    var editorContent = qaNotes ? draftToHtml(convertToRaw(qaNotes.getCurrentContent())) : '';
    if (tmpQaType === 'approve') {
      editorContent = `<p><b><em> Approved By ${userName} </em></b></p>` + editorContent;
      dispatch(
        approveSuppliers({
          ids: supIds,
          supplierType: supType ? supType : qaSupplierType,
        })
      ).then(async () => {
        await dispatch(
          addSupplierHistory({
            supplierId: supIds,
            note: editorContent,
            noteType: 'changelog',
          }, false)
        )
        page === '' && getSuppliersDataOnApproveOrReject(searchList, supType ? supType : qaSupplierType, supplierParams)
      })
    } else if (tmpQaType === 'reject') {
      editorContent = `<p><b><em> Rejected By ${userName} </em></b></p>` + editorContent;
      dispatch(
        rejectSuppliers({
          ids: supIds,
          supplierType: supType ? supType : qaSupplierType,
          isReenable
        })
      ).then(async () => {
        await dispatch(
          addSupplierHistory({
            supplierId: supIds,
            note: editorContent,
            noteType: 'changelog',
          })
        )
        page === '' && getSuppliersDataOnApproveOrReject(searchList, supType ? supType : qaSupplierType)
      })
    }
  }

  const handleShowChildrensForMasters = (masterIds) => {
    if (masterIds && masterIds.length > 0) {
      setSelectedChildrens([...suppliersForQA.filter(supplier => masterIds.includes(supplier.masterId))])
      setLookupTableData([])
      return
    }
    setSelectedChildrens([])
    setLookupTableData(suppliersForQA)
  }

  const handleSelectMaster = (id) => {
    if (!selectedMasterIds || selectedMasterIds.length === 0) {
      setSelectedMasterIds([id])
      return
    }
    const isExisted = selectedMasterIds.findIndex(masterId => masterId === id)
    if (isExisted !== -1) {
      setSelectedMasterIds([...selectedMasterIds.filter(masterId => masterId !== id)])
    } else {
      setSelectedMasterIds([...selectedMasterIds, id])
    }
  }

  const getSuppliersDataOnApproveOrReject = async (searchList = {}, qaSupplierType, supplierParams) => {
    const supParams = supplierParams ? { ...supplierParams } : { ...suppliersDataParams }
    if (qaSupplierType === 'master') {
      await dispatch(getMasterSuppliersCountForQA({
        pending: supParams?.showPending,
        approved: supParams?.showApproved,
        rejected: supParams?.showRejected,
        searchList
      })).then(masterResponse => {
        setTotalMasterRecords(masterResponse.count || 0)
      })
      await dispatch(getMasterSuppliersForQA({
        limit: supParams?.limit,
        offset: supParams?.limit * (supParams?.page - 1),
        pending: supParams?.showPending,
        approved: supParams?.showApproved,
        rejected: supParams?.showRejected,
        searchList
      })).then(masterRes => {
        setIsQANoteSubmitted(true)
        setMasterTableData(masterRes)
      })
    }
    else {
      dispatch(getLocationMasterSuppliersCountForQA({
        pending: supParams?.showPending,
        approved: supParams?.showApproved,
        rejected: supParams?.showRejected,
        searchList
      })).then(response => {
        setTotalLocationBasedMasterRecords(response.count)
      })
      await dispatch(getLocationBasedMasterSuppliersForQA({
        limit: supParams?.limit,
        offset: supParams?.limit * (supParams?.page - 1),
        pending: supParams?.showPending,
        approved: supParams?.showApproved,
        rejected: supParams?.showRejected,
        searchList
      })).then(res => {
        setIsQANoteSubmitted(true)
        setLocationBasedMasterTableData(res)
      })
    }
  }

  const updateIsQANoteSubmitted = () => {
    setIsQANoteSubmitted(false)
  }

  const onSupplierChange = (e) => {
    setSearchSupplier(e.target.value)
    setSearchList((prevState) => {
      return {
        ...prevState,
        supplier: e.target.value
      }
    })
    setSearchBoolean(false)
  }

  const onChangeDateFrom = (e) => {
    setDateFrom(e.target.value);
    setSearchList((prevState => {
      return {
        ...prevState,
        dateFrom: e.target.value
      }
    }))
  }

  const onChangeDateTo = (e) => {
    setDateTo(e.target.value);
    setSearchList((prevState) => {
      return {
        ...prevState,
        dateTo: e.target.value
      }
    })
  }

  const onSearch = async () => {
    if (currentTab === "lookup") {
      await getSuppliersDataOnApproveOrReject(searchList, "master", null)
      await getSuppliersDataOnApproveOrReject(searchList, "locationBased", null)
    } else {
      getMatchedChildren(page, limit, 0, searchList)
    }
  }

  const onCancelFilter = async () => {
    setSearchList({})
    setDateFrom("")
    setDateTo('');
    setSearchSupplier("");
    await getSuppliersDataOnApproveOrReject({}, "master", null)
    await getSuppliersDataOnApproveOrReject({}, "locationBased", null)
  }

  const onClickDateFrom = () => {
    dateFromRef.current.showPicker();
  }

  const onClickDateTo = () => {
    dateToRef.current.showPicker();
  }

  const onReset = () => {
    getMatchedChildren(1, 10, 0)
    setPage(1)
    setSearchSupplier("")
    setCheckedKeys([])
    setSelectedMatchedChildOrphans([])
  }

  const onSearchPendingSuppliers = (event) => {
    if (event.key === 'Enter') {
      getMatchedChildren(page, limit, 0, searchList)
    } else if (event.type === 'click') {
      getMatchedChildren(page, limit, 0, searchList)
    }
  }

  return (

    <CommonContainer>
      <div className="page-tabs">
        {
          tabs.map(tab => (
            <button
              key={tab.value}
              type="button"
              className={`page-tab${currentTab === tab.value ? ' selected' : ''}`}
              onClick={() => { handleClickTab(tab.value) }}
            >
              {tab.label}
            </button>
          ))
        }
      </div>
      <div className='searchAndFilterBox'>
        <div className='search_container'>
          <input
            placeholder={currentTab === 'lookup' ? 'Supplier' : 'Child Supplier'}
            className='search_input'
            value={searchSupplier}
            onChange={onSupplierChange}
            onKeyDown={onSearchPendingSuppliers}
          />
        </div>
        {currentTab === 'lookup' && <div className='date_main_container'>
          <label className='date_label'>Date</label>
          <div className='date_container'>
            <div className='h-100'>
              <input type='date' ref={dateFromRef} onChange={(e) => { onChangeDateFrom(e) }} className='h-100 border-0' onClick={onClickDateFrom} />
            </div>
            <label>To</label>
            <div className='h-100'>
              <input type='date' ref={dateToRef} onChange={(e) => { onChangeDateTo(e) }} className='h-100 border-0' onClick={onClickDateTo} />
            </div>
          </div>
        </div>}
        <div>
          <button className='btn btn-secondary btn-lg' onClick={currentTab === "lookup" ? onCancelFilter : onReset}>{currentTab === "lookup" ? "Cancel" : "Reset"}</button>
          <button
            className='btn btn-secondary btn-lg mx-4'
            onClick={currentTab === 'lookup' ? onSearch : onSearchPendingSuppliers}
          >
            Search
          </button>
        </div>
      </div>
      {
        currentTab === 'lookup' ? (
          <>
            <div className="quality-component1 d-flex flex-column row-gap-5 mt-5">
              <QualityMasterSuppliersComponent
                tableData={masterTableData}
                onApproveSuppliers={handleApproveSuppliers}
                onRejectSuppliers={handleRejectSuppliers}
                onGoToMasterDetail={handleGoToSupply}
                isLoading={isLoadingMasterSupplier}
                masterSuppliers={masterSuppliersForQA}
                onSelectChildren={handleShowChildrensForMasters}
                onSelectMaster={handleSelectMaster}
                selectedMasterIds={selectedMasterIds}
                totalMasterRecords={totalMasterRecords}
                isQANoteSubmitted={isQANoteSubmitted}
                updateIsQANoteSubmitted={updateIsQANoteSubmitted}
                searchList={searchList}
                searchBoolean={searchBoolean}
                onConfirmAndReenable={onConfirmAndReenable}
              />
              <QualityLocationBasedMasterSuppliersComponent
                tableData={locationBasedMasterTableData}
                onApproveSuppliers={handleApproveSuppliers}
                onRejectSuppliers={handleRejectSuppliers}
                isLoading={isLoadingLocationMasterSupplier}
                totalLocationMasterRecords={totalLocationBasedMasterRecords}
                isQANoteSubmitted={isQANoteSubmitted}
                updateIsQANoteSubmitted={updateIsQANoteSubmitted}
                searchList={searchList}
                searchBoolean={searchBoolean}
              />
            </div>
          </>
        ) : (
          <AutoMatchedChildren
            isLoadingOrphans={isLoadingOrphans}
            matchedChildOrphans={matchedChildOrphans}
            totalMatchedChildRecords={totalMatchedChildRecords}
            limit={limit}
            page={page}
            onChangePageHandler={onChangePageHandler}
            handleChangeLimit={handleChangeLimit}
            checkedKeys={checkedKeys}
            setCheckedKeys={setCheckedKeys}
            checked={checked}
            indeterminate={indeterminate}
            handleCheckAll={handleCheckAll}
            handleCheck={handleCheck}
            getMatchedChildren={getMatchedChildren}
            searchList={searchList}
            setSearchList={setSearchList}
            handleSubmitQA={handleSubmitQA}
            selectedMatchedChildOrphans={selectedMatchedChildOrphans}
            setSelectedMatchedChildOrphans={setSelectedMatchedChildOrphans}
          />
        )
      }

      {showQaPromt && <QaNotesModal
        show={showQaPromt}
        onClose={() => setShowQaPromt(false)}
        onDone={handleSubmitQA}
        qaReject={true}
      />}
    </CommonContainer>
  )
}

export default QualityComponent